export enum TrustStatus {
  INCOMING = 'They trust you',
  OUTGOING = 'You trust them',
  MUTUAL = 'Mutual trust',
  NONE = 'No Trust',
  PENDING = 'Pending',
}
